import { Injectable, inject } from '@angular/core';
import {
  ApiDependencyProviderService,
  CollectionRequest,
  CollectionResponse,
  HttpParams,
} from '@web/common';
import { map, Observable } from 'rxjs';
import { Guid } from '@web/utils';
import { PublicDictionaryCountryCollectionItemResponse } from '../responses/public-dictionary-country-collection-item.response';
import { PublicDictionaryCountryDetailsResponse } from '../responses/public-dictionary-country-details.response';

@Injectable({
  providedIn: 'root',
})
export class PublicDictionaryCountryApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchCollection(
    request: CollectionRequest,
    cache = false,
  ): Observable<
    CollectionResponse<PublicDictionaryCountryCollectionItemResponse>
  > {
    const path = 'dictionary/country';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      this.provider.httpHelper.collectionRequestToQueryParams(request),
    );
    const context = this.provider.httpContextBuilder
      .skipByLoadingInterceptor()
      .skipByHttpErrorInterceptor()
      .withOptionalCacheInterceptor(() => cache)
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToCollectionResponse(
            PublicDictionaryCountryCollectionItemResponse,
          ),
        ),
      );
  }

  public fetchDetailsById(
    id: Guid,
  ): Observable<PublicDictionaryCountryDetailsResponse> {
    const path = `dictionary/country/${HttpParams.Id}`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Id]: id,
    });
    const context = this.provider.httpContextBuilder
      .skipByLoadingInterceptor()
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(
            PublicDictionaryCountryDetailsResponse,
          ),
        ),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
